import * as firebase from 'firebase'
import axios from 'axios';
import { fileURLToPath } from 'url';
let database;
const firebaseConfig = {
    apiKey: "AIzaSyDg7lO0ZnDC4z0DIyKfWSKdOXi2oYX-JwM",
    authDomain: "ssangkyomembership.firebaseapp.com",
    databaseURL: "https://ssangkyomembership-default-rtdb.firebaseio.com",
    projectId: "ssangkyomembership",
    storageBucket: "ssangkyomembership.appspot.com",
    messagingSenderId: "890315333170",
    appId: "1:890315333170:web:179e5f8371f39ad824662b",
    measurementId: "G-PJY42Q6L9R"
  };

export const fire = () => {
    if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
    }
    database = firebase.database();
}

// 유저 관련
export const getUserList = () => {
    return database.ref('/users').once('value')
}

export const getInvalidateDay = () => {
    return database.ref('/invalidateDay').once('value');
}

export const getSpots = () => {
    return database.ref('/spots').once('value');
}

export const removeUsers = () => {
    return database.ref('/users').remove();
}


export const createUserList = (userList) => {
    return database.ref(`/users/`).set(userList)
}

